import type { useHistory } from 'react-router-dom';
import { CreatePageResponse } from '@applied/proto/web_services/candidate_experience/proto/page_pb';
import {
  EmployeeInfoResponse,
  EmployeeOffersResponse,
} from '@applied/proto/web_services/candidate_experience/proto/web_offer_pb';
import type { JsonValue, MessageType } from '@protobuf-ts/runtime';
import type { ResponseData } from 'api/http_requests';
import { getData, makeAuthenticatedRequest, postData } from 'api/http_requests';

const employeeInfoResponseType = EmployeeInfoResponse as MessageType<EmployeeInfoResponse>;
const employeeOffersResponseType = EmployeeOffersResponse as MessageType<EmployeeOffersResponse>;
const createPageResponseType = CreatePageResponse as MessageType<CreatePageResponse>;

export async function getEmployeeInfo(
  history: ReturnType<typeof useHistory>,
): Promise<EmployeeInfoResponse | null> {
  const requestEmployeeInfo = (): Promise<ResponseData<JsonValue>> => getData('/api/employee/info');
  const response = await makeAuthenticatedRequest(requestEmployeeInfo, history);
  if (!response || response.jsonPayload === null) {
    return null;
  }
  return employeeInfoResponseType.fromJson(response.jsonPayload);
}

export async function getEmployeeOffers(
  history: ReturnType<typeof useHistory>,
): Promise<EmployeeOffersResponse | null> {
  const requestEmployeeOffers = (): Promise<ResponseData<JsonValue>> =>
    getData('/api/employee/offers');
  const response = await makeAuthenticatedRequest(requestEmployeeOffers, history);
  if (!response || response.jsonPayload === null) {
    return null;
  }
  return employeeOffersResponseType.fromJson(response.jsonPayload);
}

export async function createPage(
  history: ReturnType<typeof useHistory>,
): Promise<CreatePageResponse | null> {
  const requestCreatePage = (): Promise<ResponseData<JsonValue>> =>
    postData('/api/pages/create', {});
  const response = await makeAuthenticatedRequest(requestCreatePage, history);
  if (!response || response.jsonPayload === null) {
    return null;
  }
  return createPageResponseType.fromJson(response.jsonPayload);
}
